(ns portal.adserver-table.view
  (:require ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/x-data-grid-premium" :refer [DataGridPremium]]
            ["src/svg/inform/plus.svg$default" :as Plus]
            [cljs-bean.core :as bean]
            [clojure.string :as str]
            [common.flags :refer [use-flag]]
            [common.resource.query.adserver :as adserver.q]
            [common.resource.query.adserver-account :as adserver-account.q]
            [common.widgets.data-grid :as dg]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn- render-adserver-cell [{:keys [row value]}]
  (let [adserver-id (get-in row [:adserver :id])
        xandr-enabled? (use-flag :xandr-adserver-support)
        is-xandr? (and (adserver.q/xandr-adserver? adserver-id) (not xandr-enabled?))]
    ($ Stack {:direction "row" :alignItems "center" :gap 1}
       value
       (when is-xandr?
         ($ Chip
            {:label "Deprecated"
             :size "small"
             :color "warning"
             :variant "subtle"})))))

(def ^:private columns
  #js [#js {:field "name"
            :headerName "Name"
            :type "string"
            :minWidth 200
            :flex 2
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (:name row))}
       #js {:field "adserver"
            :headerName "Adserver"
            :type "string"
            :minWidth 200
            :flex 1
            :sortable false
            :valueGetter (fn [_value row ^js _column ^js _apiRef]
                           (-> row
                               (get-in [:adserver :name])
                               adserver.q/rename-adserver-to-new-name))
            :renderCell (uix/as-react render-adserver-cell)}])

(def Toolbar
  (uix/as-react
   (fn [{:keys [is-adserver-create-allowed quick-filter-props]}]
     ($ dg/grid-toolbar
        {:quick-filter-props quick-filter-props}
        (when is-adserver-create-allowed
          ($ Button
             {:onClick #(rf/dispatch [:ocp/open {:id :adserver/crud}])
              :variant "contained"
              :startIcon ($ Plus)
              :data-testid "createAdserverButton"}
             "Add Adserver"))))))

(defn- get-row-id [row]
  (:id row))

(def get-row-count (comp :total :_meta))

(defui adserver-data-grid []
  (let [{:keys [agency-id]} (use-subscribe [:url-context])

        on-row-click (uix/use-callback
                      (fn [^js params]
                        (rf/dispatch [:ocp/open {:id :adserver/crud
                                                 :props {:adserver (.-row params)}}]))
                      [])

        table-query-fn (uix/use-callback
                        (fn [{:keys [^js filter-model ^js sort-model ^js pagination-model]}]
                          (adserver-account.q/adserver-accounts-paginated-query
                           {:agency-id agency-id
                            :term (str/join " " (.-quickFilterValues filter-model))
                            :sort (bean/->clj (first sort-model))
                            :page-size (.-pageSize pagination-model)}))
                        [agency-id])

        server-table-props (dg/use-server-table-props
                            {:table-query-fn table-query-fn
                             :disable-default-transform true
                             :transform-response-fn :_items
                             :get-row-count-fn get-row-count
                             :initial-pagination-model #js {:page 0 :pageSize 10}
                             :initial-sort-model #js [#js {:field "name" :sort "asc"}]})

        is-adserver-create-allowed (use-subscribe [:resource.user/allowed? "adservers.create"])]

    ($ DataGridPremium
       (merge
        server-table-props
        {:columns columns
         :getRowId get-row-id
         :onRowClick on-row-click
         :disableRowSelectionOnClick true

         :slots #js {:row dg/WithDynamicPropsRow
                     :toolbar Toolbar}
         :slotProps #js {:baseTextField dg/grid-toolbar-outlined-input
                         :row #js {:get-props-fn (fn [props]
                                                   {:data-testid (-> props :row :name)})}
                         :toolbar #js {:is-adserver-create-allowed is-adserver-create-allowed
                                       :quick-filter-props {:inputProps #js {:data-testid "searchInput"}}}}
         :data-testid "table-adserver"
         :sx #js {:maxHeight "70rem"
                  "& .MuiDataGrid-row:hover" #js {:cursor "pointer"}}}))))
